// app/lib/tracking/ga4.ts

/**
 * GA4'e custom event gönder. Consent Mode default denied olduğu için
 * onay yoksa Google modeling yapar, gerçek hit gönderilmez.
 */
export const trackGa4Event = (
  eventName: string,
  params: Record<string, unknown> = {},
): void => {
  if (typeof window === "undefined" || typeof window.gtag !== "function")
    return;
  window.gtag("event", eventName, params);
};
